import {createAction, handleActions} from 'redux-actions';
import * as func from "../../utils/functions";

const SET_SCHOLARS = 'scholar/SET_SCHOLARS';
export const setScholars = createAction(SET_SCHOLARS);
const SET_SCHOLAR = 'scholar/SET_SCHOLAR';
export const setScholar = createAction(SET_SCHOLAR);

// 초기 state를 정해줍니다
let initialState = {
	param: {
		'current_page': 1,
		'record_per_page': 20,
		'ks': '',
		'sub_ks': '',
		'collabo_org': [],
		'sinbun_name': [],
		'dept_name': [],
		'order_by': 'date',
		'order': 'desc',
		'date_type' : 'input_date',
		'in_date_start' : '',
		'in_date_end' : '',
		'scholar_status' : [],
		'worker_name' : '',
	},
	records: [],
	checkedRecords : [],
	facet: {},
	totalRecords: 0,
	totalPage: 0,
	record: {},
	meta: {},
	stats: {},
	code: {},
	fullText: [],
	showSide : func.getCookie('side') === 'true' ? 'true' : 'false'
}

export default handleActions({
	[SET_SCHOLARS]: (state, action) => {
		// console.log(state);
		action.payload = action.payload ? action.payload : {}
		return {
			...state,
			param: {
				...state.param,
				current_page: action.payload.param && action.payload.param.current_page ? action.payload.param.current_page : state.param.current_page,
				records_per_page: action.payload.param && action.payload.param.records_per_page ? action.payload.param.records_per_page : state.param.records_per_page,
				ks: action.payload.param && action.payload.param.ks ? action.payload.param.ks : state.param.ks,
				sub_ks: action.payload.param && action.payload.param.sub_ks ? action.payload.param.sub_ks : state.param.sub_ks,
				collabo_org: action.payload.param && action.payload.param.collabo_org ? action.payload.param.collabo_org : state.param.collabo_org,
				sinbun_name: action.payload.param && action.payload.param.sinbun_name ? action.payload.param.sinbun_name : state.param.sinbun_name,
				dept_name: action.payload.param && action.payload.param.dept_name ? action.payload.param.dept_name : state.param.dept_name,
				order_by: action.payload.param && action.payload.param.order_by ? action.payload.param.order_by : state.param.order_by,
				order: action.payload.param && action.payload.param.order ? action.payload.param.order : state.param.order,
				date_type : action.payload.param && action.payload.param.date_type ? action.payload.param.date_type : state.param.date_type,
				in_date_start : action.payload.param && action.payload.param.in_date_start ? action.payload.param.in_date_start : state.param.in_date_start,
				in_date_end : action.payload.param && action.payload.param.in_date_end ? action.payload.param.in_date_end : state.param.in_date_end,
				scholar_status: action.payload.param && action.payload.param.scholar_status ? action.payload.param.scholar_status : state.param.scholar_status,
				worker_name: action.payload.param && action.payload.param.worker_name ? action.payload.param.worker_name : state.param.worker_name,
			},
			records: action.payload.records ? action.payload.records : state.records,
			checkedRecords : action.payload.checkedRecords ? action.payload.checkedRecords : state.checkedRecords,
			facet: action.payload.facet ? action.payload.facet : state.facet,
			totalRecords: action.payload.pageInfo ? action.payload.pageInfo.totalResults : state.totalRecords,
			totalPage: action.payload.pageInfo ? action.payload.pageInfo.totalPage : state.totalPage
		}
	},
	[SET_SCHOLAR]: (state, action) => {
		return {
			...state,
			record: action.payload.record ? action.payload.record : state.record,
			meta: action.payload.meta ? action.payload.meta : state.meta,
			stats: action.payload.stats ? action.payload.stats : state.stats,
			code: action.payload.code ? action.payload.code : state.code,
			fullText: action.payload.fullText ? action.payload.fullText : state.fullText,
			showSide: action.payload.showSide ? action.payload.showSide : state.showSide,
		}
	},
}, initialState)
